import { Form, Select } from 'antd';
import React from 'react';

import { L } from '@lib';
import { SelectStringDictionary } from '@models';

interface IRoleProps {
  label?: string;
  required?: boolean;
  name?: string;
  options: SelectStringDictionary[];
  onChange?:
    | ((value: string[], option: SelectStringDictionary | SelectStringDictionary[] | undefined) => void)
    | undefined;
  mode?: 'multiple' | 'tags';
}

const RoleSelect: React.FC<IRoleProps> = ({
  label = 'Select role',
  required = false,
  name,
  onChange,
  mode,
  options,
}) => {
  return (
    <Form.Item label={label} name={name} rules={[{ required, message: L('Role is required') }]}>
      <Select
        showSearch
        allowClear
        mode={mode}
        onChange={onChange}
        placeholder={L('Role')}
        filterOption={false}
        options={options}
      />
    </Form.Item>
  );
};

export default RoleSelect;
